const state = {
  height: '',
  printLabels: [],
  orderList: [],
  orderInfo: {},
  language: 'zh'
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js